import React from "react";
import Modal from "./Modal";

const Impressum = () => {
  return (
    <Modal title="Impressum" id="impressum-modal">
      {" "}
      <p>
        <strong>Herausgeber:</strong>
      </p>
      <p>
        Aioi Nissay Dowa Insurance Company of Europe SE, Niederlassung
        Deutschland
      </p>
      <p>
        Carl-Zeiss-Ring 25 <br /> 85737 Ismaning
      </p>
      Tel. <a href="tel:+49892444740">+49 89 244474 0</a>
      <br />
      E-Mail:{" "}
      <a href="mailto:kundenservice@aioinissaydowa.eu">
        kundenservice@aioinissaydowa.eu
      </a>
      <br />
      Internet:{" "}
      <a href="https://aioinissaydowa.eu/" target="_blank">
        www.aioinissaydowa.eu
      </a>
      <p>Vertreten durch den Hauptbevollm&auml;chtigten Martin Spangenberg</p>
      <p>
        <strong>Sitz der Gesellschaft:</strong>
      </p>
      <p>Ismaning</p>
      <p>
        <strong>Rechtsform:</strong>
      </p>
      <p>
        Das Unternehmen ist eine Niederlassung der Aioi Nissay Dowa Insurance
        Company of Europe SE, europ&auml;ische Aktiengesellschaft mit Sitz in 4,
        rue Lou Hemmer, L-1748 Senningerberg, Luxemburg, eingetragen im Handels-
        und Firmenregister von Luxemburg unter Nr. B232302.
      </p>
      <p>
        Gesch&auml;ftsf&uuml;hrende Direktoren: Christian Alt, Roger
        McCorriston, Steve S&eacute;r&egrave;mes, Michael Kainzbauer, Dr. Thomas
        Jannakos, Michael Swanborough; Vorsitzender des Verwaltungsrats: Michael
        Kainzbauer.
      </p>
      <p>
        <strong>Handelsregistereintrag:</strong>
      </p>
      <p>Amtsgericht M&uuml;nchen HRB 155874</p>
      <p>
        <strong>Ust.-IdNr.:</strong>
      </p>
      <p>DE 241484675</p>
      <p>
        <strong>Aufsichtsbeh&ouml;rde:</strong>
      </p>
      <p>
        Bundesanstalt f&uuml;r Finanzdienstleistungsaufsicht, Graurheindorfer
        Stra&szlig;e 108, 53117 Bonn
      </p>
      <p>Versicherungsombudsmann e.V., Postfach 080632, 10006 Berlin</p>
      <p>
        <strong>Verantwortlicher nach &sect; 18 MStV:</strong>
      </p>
      <p>
        Aioi Nissay Dowa Insurance Company of Europe SE, Niederlassung
        Deutschland
      </p>
      <p>Herr Martin Spangenberg</p>
      <p>Carl-Zeiss-Ring 25</p>
      <p>85737 Ismaning</p>
    </Modal>
  );
};

export default Impressum;
